<template>
  <div class="question-container" style="border: 1px solid #edeff2">
    <div class="question-type">下载附件</div>
    <div class="title-view">
      <p style="color: #4c4a56">
        <span v-if="dataObj.isMust === 1" class="asterisk">*</span>
        {{ `${dataObj.questionIndex ? dataObj.questionIndex : index + 1}、` }}
        <span style="color: #4c4a56">
          {{ `${dataObj.caseProblem}` }}
        </span>
      </p>
    </div>

    <div class="question-images">
      <div
        v-for="(item, idx) in images"
        :key="idx"
        style="margin-top: 10px; position: relative"
      >
        <img :src="item" style="width: 100%" />
      </div>
    </div>

    <div class="upload-file">
      <div class="file-item" v-for="(file, index) in fileList" :key="index">
        <div class="filename">
          <img
            class="icon"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1762401082820.svg"
          />
          <span>{{ file.fileName || `文件${index + 1}` }}</span>
        </div>
        <div class="down">
          <img
            src="https://ossfastmake.mustke.com/qrCode/tupian/1761210480786.svg"
            mode=""
          />
          下载
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      dataObj: {},
      index: 0,
      images: [],
      fileList: [],
    };
  },
  watch: {
    params: {
      handler(newVal) {
        if (!newVal) return;
        this.dataObj = newVal.data || {};
        this.index = newVal.index || 0;

        try {
          this.images = JSON.parse(this.dataObj.caseProblemImg || "[]");
        } catch (e) {
          this.images = [];
        }

        try {
          const chooseList = JSON.parse(
            this.dataObj.chooseList || '{"list": []}',
          );
          this.fileList = chooseList.list || [];
        } catch (e) {
          this.fileList = [];
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.file-item {
  margin-top: 8px;
}

.file-link {
  color: #3a60ff;
  text-decoration: underline;
  cursor: pointer;
}

.upload-file {
  margin: 10px 0;
}

.upload-file .file-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.upload-file .file-item .filename {
  max-width: 80%;
  display: flex;
  align-items: center;
  gap: 8.5px;
}

.upload-file .file-item .filename .icon {
  width: 24px;
  height: 21px;
  flex: none;
}
.upload-file .file-item .filename span {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  color: #333;
}

.upload-file .file-item + .file-item {
  margin-top: 5px;
}

.upload-file .file-item .down {
  width: 59px;
  height: 31.5px;
  background: #3a60ff;
  border-radius: 5px;
  font-size: 13px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5.5px;
}

.upload-file .file-item .down img {
  width: 10px;
  height: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionPreview/QuestionPreviewDownloadFile.vue